// Dependencies
import { FC } from "react";

// Components
import AddMemberForm from "~/containers/Wallets/AddMemberForm";

// Styles
import { StyledWrapper } from "./WalletAddMember.styled";
import { StyledAddLabel } from "~/components/Layout/LayoutAdd";

interface WalletAddMemberProps {
  walletId: string;
  members?: string[];
  onClose: Function;
}

const WalletAddMember: FC<WalletAddMemberProps> = ({
  walletId,
  members,
  onClose,
}) => {
  return (
    <StyledWrapper>
      <StyledAddLabel>Share Wallet</StyledAddLabel>
      <AddMemberForm walletId={walletId} members={members} onClose={onClose} />
    </StyledWrapper>
  );
};

export default WalletAddMember;
